import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { ConfigService } from "../../../services";
import { shapes } from "../../../enums"; //  our custom components

import Image from "../../core/image";
import ContentItem from "../content-item";
var ContentCardAvatar = createComponent({
  displayName: 'ContentCardAvatarCmp',
  propTypes: {},
  defaultProps: {},
  render: function render(p) {
    var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

    return p.children ? /*#__PURE__*/React.createElement("div", {
      className: "content-card-avatar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-avatar__inner"
    }, /*#__PURE__*/React.isValidElement(p.children) ? p.children : /*#__PURE__*/React.createElement(ContentItem, {
      image: p.children.imageSrc,
      imageStyles: {
        shape: shapes.CIRCULAR
      },
      header: p.children.userName,
      meta: /*#__PURE__*/React.createElement("div", {
        className: "content-card-meta"
      }, p.children.network ? /*#__PURE__*/React.createElement("div", {
        className: "content-card-meta__network"
      }, /*#__PURE__*/React.createElement(Image, {
        src: ConsoleKitConfig.assetUrls.assetFolderPath + "misc/" + p.children.network + "-logo-tiny.png"
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "content-card-meta__userhandle"
      }, p.children.userHandle), /*#__PURE__*/React.createElement("div", {
        className: "content-card-meta__timestamp"
      }, p.children.timestamp ? "on " + p.children.timestamp : undefined))
    }))) : null;
  }
});
export default ContentCardAvatar;
//# sourceMappingURL=content-card-avatar.js.map